import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

function Footer() {
    return (
        <Box
            sx={{
                backgroundColor: '#333', // Dark background
                color: '#fff',          // White text
                padding: 3,
                textAlign: 'center',
                borderTop: '2px solid #444',
                width: '100%',
                position: 'static',
                marginTop: 'auto',
            }}
        >
            <Typography variant="body2">
                © 2025 SciCruit. All Rights Reserved.
            </Typography>
            <Stack
                direction="row"
                justifyContent="center"
                spacing={2}
                sx={{ marginTop: 1 }}
            >
                <a
                    href="/privacy"
                    style={{
                        color: '#fff',
                        textDecoration: 'none',
                    }}
                >
                    Privacy Policy
                </a>
                <a
                    href="/terms"
                    style={{
                        color: '#fff',
                        textDecoration: 'none',
                    }}
                >
                    Terms of Service
                </a>
            </Stack>
        </Box>
    );
}

export default Footer;
